// Where people leave (backend core/funnel): each step a visit reaches, under a random id made for this browser
// tab — no email, no cookie. Fire and forget: counting never slows or breaks the app.
import { API } from "./constants";

const KEY = "ju_funnel";

function session() {
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id = (Math.random().toString(36).slice(2) + Date.now().toString(36)).slice(0, 24);
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

// Where they first came from (a link, a search, a campaign): kept from their first visit on this browser.
function source() {
  try {
    let saved = localStorage.getItem("ju_source");
    if (!saved) {
      const q = new URLSearchParams(window.location.search);
      saved = JSON.stringify({ referrer: document.referrer || "", utm_source: q.get("utm_source") || "",
                               utm_medium: q.get("utm_medium") || "", utm_campaign: q.get("utm_campaign") || "" });
      localStorage.setItem("ju_source", saved);
    }
    return JSON.parse(saved);
  } catch {
    return null;
  }
}

source();      // read at the first load, before any page change drops the link's ?utm_ parameters

// This tab's funnel id: given with the sign-in code, the steps taken before the email join their row.
export function visitId() {
  return session();
}

export function trackStep(step) {
  const id = session();
  if (!id || !step) return;
  try {
    // plain text: a simple cross-origin request with no preflight, so it also leaves while the page closes.
    // Signed in, the session token goes with it and the step joins their row (backend core/users).
    let token = null;
    try { token = localStorage.getItem("jf_session"); } catch { /* private mode */ }
    // where they first came from and the kind of screen ride with every step, signed in or not (backend core/funnel)
    const body = JSON.stringify({ session: id, step, source: source(), w: window.innerWidth, ...(token ? { token } : {}) });
    fetch(`${API}/funnel`, { method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body, keepalive: true }).catch(() => {});
  } catch { /* never in the traveller's way */ }
}
